import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-t from-[#040406] to-[#000000] text-white py-10 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
        {/* Branding and Tagline */}
        <div className="text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl font-bold">Wellness Spa</h2>
          <p className="text-xs sm:text-sm text-gray-400 mt-1">
            Entspannung und Wohlbefinden für Körper und Geist
          </p>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-sm sm:text-base">
          <a href="/about" className="hover:text-gray-300 transition">
            Über uns
          </a>
          <a href="/services" className="hover:text-gray-300 transition">
            Dienstleistungen
          </a>
          <a href="/contact" className="hover:text-gray-300 transition">
            Kontakt
          </a>
          <a href="/impressum" className="hover:text-gray-300 transition">
            Impressum
          </a>
        </nav>
      </div>

      {/* Copyright */}
      <div className="mt-6 border-t border-gray-700 pt-4 text-center">
        <p className="text-xs sm:text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Wellness Spa. Alle Rechte
          vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
